import { makeStyles } from '@material-ui/core/styles';
import { FC } from 'react';
import pure from 'recompose/pure';

import { Customer, FieldProps } from '../../interface/types';
import AvatarField from './AvatarField';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
  },
  avatar: {
    marginRight: theme.spacing(1),
    textTransform: 'capitalize',
  },
}));

interface Props extends FieldProps<Customer> {
  size?: string;
}

const FullNameField: FC<Props> = ({ record, size }) => {
  const classes = useStyles();
  return record ? (
    <div className={classes.root}>
      <AvatarField className={classes.avatar} record={record} size={size} />
      {record?.user?.firstName
        ? record?.user?.firstName
        : record?.firstName
        ? record?.firstName
        : record?.name}
    </div>
  ) : null;
};

const PureFullNameField = pure(FullNameField);

PureFullNameField.defaultProps = {
  source: 'firstName',
  label: 'resources.users.fields.firstName',
};

export default PureFullNameField;
